<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import WEventTopBox from '@/views/event/event-hist/components/EventTopBox';

import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapEventTopBox',
  extends: WEventTopBox,
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler(value) {
        if (value === false) {
          this.clear();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active) {
        return;
      }
      this.isLoading = true;
      const params = {
        startDatetime: moment().subtract(1, 'days').valueOf(),
        endDatetime: moment().valueOf(),
        chartType: this.chartType,
        chartLimit: this.chartLimit,
        mapId: this.$store.getters.getCurrentMapId,
      };

      this.setEventHistStatsParams(params);
      MapAPI.getEventHistStatsGroupByObjTopN(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.isEmptyData = !(result.data.length > 0);
          this.setEventTopNData(result.data);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    clear() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapEventTopBox.vue